import Link from 'next/link';
import React from 'react';
import { Page, Keyable } from '@model/common';
import { PlainLinkStyles } from '@styles/common';

export interface HelpLinkProps {
  path: string;
  children?: any;
}

enum PathRefByPageType {
  'info' = '[pageId]',
  'offers' = '[offerType]'
}

const getEnumKeyByValue = (E: Keyable, value: string) => (Object.entries(E).find(([_, val]) => val === value) || [])[0];

export const OfferLink = ({ path, children }: HelpLinkProps) => {
  const [_, type] = path.split('/');
  const pageType = getEnumKeyByValue(Page, `/${type}`);

  return (
    <Link
      prefetch={false}
      href={`${pageType ? Page[pageType] : Page.OFFERS}/${PathRefByPageType[type]}`}
      as={path}
      passHref
      style={PlainLinkStyles}
    >
      {children}
    </Link>
  );
};
